export function getOrderTypeLabel(orderType, role) {
  switch (orderType) {
    case 0:
      return "New";
    case 1:
      return "Change";
    case 2:
      return "Disconnect";
    case 3:
      return "Feature";
    case 4:
      return "New DMT";
    case 5:
      return "Delete DMT";
    case 6:
      return role <= 2 ? "Non-supported Carrier" : "Manual Order";
    case 7:
      return "International New Order";
    case 8:
      return "Upcoming Port";
    case 9:
      return "Ported Numbers"
    case 10:
      return "Port Completed"
    default:
      return "";
  }
}
